import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

export async function postBillingInfo<T>(body: T) {
  return axiosFetch.post("/api/BillingInformation/upsert", body);
}

export async function getBillingInfoByReservation(reservationId: string) {
  return axiosFetch.get(
    `/api/BillingInformation/getByReservationId/${reservationId}`
  );
}
